<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：状态统计
    -->
<div class="meter-charge">
		<div class="meter_search" style="height: 58px;margin-top: 20px;margin-bottom: 30px;">
			<el-form :inline="true" :model="select" class="demo-form-inline" @keyup.enter.native="search">
				<el-form-item label="户号">
					<el-input v-model="select.account" placeholder="户号" style="width:200px;" :maxlength="12"></el-input>
				</el-form-item>
				<el-form-item label="表号">
					<el-input v-model="select.code" placeholder="表号" style="width:200px;" :maxlength="12"></el-input>
				</el-form-item>
				<el-form-item label="表类型">
					<el-select v-model="select.typess" placeholder="请选择" style="width: 90px;">
						<el-option v-for="item in typess" :key="item.id" :label="item.label" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="业主姓名">
					<el-input v-model="select.owner_name" placeholder="业主姓名" style="width:200px;" :maxlength="12"></el-input>
				</el-form-item>
				<el-form-item label="业主类型">
					<el-select v-model="select.nature" placeholder="请选择" style="width: 110px;">
					    <el-option
							v-for="item in natures"
							:key="item.num"
							:label="item.value"
							:value="item.num">
						</el-option>
					 </el-select>
				</el-form-item>
				<el-form-item label="地址">
					<el-input v-model="select.address" placeholder="地址" style="width:200px;"></el-input>
				</el-form-item>
				<!--<el-form-item>
						<el-radio class="radio" v-model="select.left_money_sort" label="1">升序</el-radio>
						<el-radio class="radio" v-model="select.left_money_sort" label="2">降序</el-radio>
				</el-form-item>-->
				<el-form-item>
					<el-button type="primary" @click="search">查询</el-button>
		   			<el-button type="primary" @click="resetting">重置</el-button>
		   			<el-button type="primary" @click="downmeterStatus()">导出</el-button>
				</el-form-item>
			</el-form>
		</div>  
		<el-table :data="lists" border style="width:1825px;text-align:center;margin-bottom: 10px;font-size: 12px; " v-on:sort-change="sortChange">
				<el-table-column prop="account" label="户号" width="123" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="code" label="表号" width="123" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="type" label="表类型" width="100"  align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="total_charge" label="总用量（度/吨）" width="150" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="total_money" label="总缴费金额/吨数" width="170" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="left_money" label="剩余金额/吨数" width="150" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="month_charge" label="本月用量（度/吨）" width="165" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="month_money" label="本月用量金额" width="170" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="year_charge" label="本年用量（度/吨）" width="165" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="year_money" label="本年用量金额" width="170" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="current_price" label="当前单价" width="130" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="ladder" label="当前阶梯" width="157" align="center" :sortable="false">
					<template scope="scope">
						{{scope.row.type=='水表' ? '--' : scope.row.ladder}}
			      	</template>
				</el-table-column>
				<el-table-column prop="status" label="表状态" width="110" align="center" sortable="custom">
					<template scope="scope">
				        <el-tag v-if="scope.row.status===0" type="gray">禁用</el-tag>
				        <el-tag v-if="scope.row.status===1" type="success">正常</el-tag>
			      	</template>
				</el-table-column>
				<el-table-column prop="power_status" label="通断状态" width="119" align="center" sortable="custom">
					<template scope="scope">
				        <el-tag v-if="scope.row.power_status===0" type="danger">断</el-tag>
				        <el-tag v-if="scope.row.power_status===1" type="success">通</el-tag>
			      	</template>
				</el-table-column>
				
				<el-table-column prop="nature" label="业主类型" width="110" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="owner_name" label="业主姓名" width="158" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="pocket_money" label="零钱余额" width="130" align="center" sortable="custom">
					<template scope="scope">
						<router-link class="tab_col_a" :to="{name:'smallChange', params: {orderid: scope.row.code}}">
							{{scope.row.pocket_money}}
						</router-link>
			      	</template>
				</el-table-column>
				<!--<el-table-column prop="owner_phone" label="业主手机" width="123" align="center" sortable="custom">
				</el-table-column>-->
				<el-table-column prop="address" label="地址" width="260" align="center" sortable="custom">
				</el-table-column>
				
				<!-- <el-table-column prop="type" label="表类型" width="110" align="center" sortable="custom">
				</el-table-column> -->
				<el-table-column prop="prop" label="计量方案" width="210" align="center" sortable="custom">
				</el-table-column>
				<el-table-column prop="rate" label="倍率" width="88" align="center" sortable="custom">
				</el-table-column>
		</el-table>
		 <el-pagination
	      @size-change="handleSizeChange"
	      @current-change="handleCurrentChange"
	      :page-size="15"
	      layout="total, prev, pager, next"
	      :total="totel"
	      v-if="showfenpage"
	      >
	    </el-pagination>
	</div>
</template>

<script>
	import { mapState} from 'vuex'
	export default{
		name:'meter-status',
		data(){
			return{
				totel:'',
				select:{
					code:'',
					account: '',
					nature:'',
					owner_name:'',
					left_money_sort:'',
					address:'',
					typess:'',
				},
				typess: [
					{
						id: '7',
						label: '水表'
					},
					{
						id: '10',
						label: '多功能单相'
					},
					{
						id: '11',
						label: '多功能三相'
					}
				],
				showfenpage:false,
				lists:[
					{
						code:'',
						account: '',
						owner_name:'',
						owner_phone:'',
						power_status:'',//通断电状态
						nature:'',
						status:'',		//电表状态
						type:'',
						month_charge:'',
						month_money:'',
						year_charge:'',
						year_money:'',
						current_price:'',
						total_money:'',
						left_monty:'',
						rate:'',
						prop:'',
						ladder:'',
						total_charge:'',
						address:'',
					}
				],
				natures:[
					/*{
						num:'0',
						value:'居民',
					},
					{
						num:'1',
						value:'自营'
					},
					{
						num:"2",
						value:'联营'
					},
					{
						num:'3',
						value:'出租'
					},
					{
						num:'4',
						value:'物业动力'
					},
					{
						num:'5',
						value:'居民配套'
					},
					{
						num:'9',
						value:'备用'
					},*/
				],
				prop:'',
				order:'',
			}
		},
		created:function(){
			this.searchNature()
			this.search()
		},
		methods:{
			searchNature(){
				this.$jssdk.member.getNature({
					
				},(res) =>{
					this.natures = res
					console.log(res)
				})
			},
			sortChange(item) {
				var order = item.order
				var prop = item.prop
				this.prop = prop
				this.order = order
				const code = this.select.code
				const account = this.select.account
		    	let nature = this.select.nature
		    	let ownerName = this.select.owner_name
				var address = this.select.address
				let typess = this.select.typess
		    	//let moneySort = this.select.left_money_sort
		      	this.$jssdk.count.meterStatus({
					meter_code:code,
					account: account,
		      		is_export:'0',
		      		nature:nature,
		      		owner_name:ownerName,
		      		sort_by: prop,
					sort_to: order,
					address:address,
					type: typess,
		      		//left_money_sort:moneySort
		      	},(data)=>{
		      		this.showfenpage = true
		      		this.lists = data.list.data
		      		this.totel= data.list.total
		      		for(var i=0;i<data.list.data.length;i++){
						if(data.data[i].nature == '0'){
							this.lists[i].nature = '居民'
						}
						if(data.data[i].nature == '1'){
							this.lists[i].nature = '自营'
						}
						if(data.data[i].nature == '2'){
							this.lists[i].nature = '联营'
						}
						if(data.data[i].nature == '3'){
							this.lists[i].nature = '出租'
						}
						if(data.data[i].nature == '4'){
							this.lists[i].nature = '物业动力'
						}
						if(data.data[i].nature == '5'){
							this.lists[i].nature = '居民配套'
						}
						if(data.data[i].nature == '9'){
							this.lists[i].nature = '备用'
						}
					}
		      		
		      		console.log(data)
		      	},(err)=>{
					return this.$message({
						type:'warning',
						message:err.msg,
						duration:1000
					})
				})
			},
			handleSizeChange(val) {
		        console.log(`每页 ${val} 条`);
		    },
		    search(){
				const code = this.select.code
				const account = this.select.account
		    	let nature = this.select.nature
		    	let ownerName = this.select.owner_name
				var address = this.select.address
				let typess = this.select.typess
		    	//let moneySort = this.select.left_money_sort
		      	this.$jssdk.count.meterStatus({
					account: account,
		      		meter_code:code,
		      		is_export:'0',
		      		nature:nature,
		      		owner_name:ownerName,
					  address:address,
					type: typess
		      		//left_money_sort:moneySort
		      	},(data)=>{
		      		this.showfenpage = true
		      		this.lists =data.list.data
		      		this.totel= data.list.total
		      		for(var i=0;i<data.list.data.length;i++){
						if(data.data[i].nature == '0'){
							this.lists[i].nature = '居民'
						}
						if(data.data[i].nature == '1'){
							this.lists[i].nature = '自营'
						}
						if(data.data[i].nature == '2'){
							this.lists[i].nature = '联营'
						}
						if(data.data[i].nature == '3'){
							this.lists[i].nature = '出租'
						}
						if(data.data[i].nature == '4'){
							this.lists[i].nature = '物业动力'
						}
						if(data.data[i].nature == '5'){
							this.lists[i].nature = '居民配套'
						}
						if(data.data[i].nature == '9'){
							this.lists[i].nature = '备用'
						}
					}
		      	},(err)=>{
					return this.$message({
						type:'warning',
						message:err.msg,
						duration:1000
					})
				})
			},
			downmeterStatus(){
				const account = this.select.account
				const code = this.select.code
				let nature = this.select.nature
				let ownerName = this.select.owner_name
				var address = this.select.address
				let typess = this.select.typess
		    	//let moneySort = this.select.left_money_sort
		      	this.$jssdk.count.meterStatus({
					account: account,
		      		meter_code:code,
		      		is_export:'1',
		      		nature:nature,
		      		owner_name:ownerName,
		      		sort_by: this.prop,
					sort_to: this.order,
					address:address,
					type: typess
		      		//left_money_sort:moneySort
		      	},(data)=>{
		      		window.location.href=data.url
		      	},(err)=>{
					return this.$message({
						type:'warning',
						message:err.msg,
						duration:1000
					})
				})
			},
			resetting(){
				this.select.code = ''
				this.select.account = ''
				this.select.nature = ''
				this.select.owner_name = ''
				this.select.address = ''
				this.select.typess = ''
		    	//this.select.left_money_sort = ''
			},
		    handleCurrentChange(val) {
				const code = this.select.code
				const account = this.select.account
				let nature = this.select.nature
				let ownerName = this.select.owner_name
				var address = this.select.address
				let typess = this.select.typess
		    	//let moneySort = this.select.left_money_sort
		      	this.$jssdk.count.meterStatus({
					account: account,
		      		meter_code:code,
		      		page:val,
		      		nature:nature,
		      		owner_name:ownerName,
		      		sort_by: this.prop,
					sort_to: this.order,
					address:address,
					type: typess
		      		//left_money_sort:moneySort
		      	},(data)=>{
		      		this.showfenpage = true
		      		this.lists = data.list.data
		      		this.totel= data.list.total
		      		for(var i=0;i<data.list.data.length;i++){
						if(data.data[i].nature == '0'){
							this.lists[i].nature = '居民'
						}
						if(data.data[i].nature == '1'){
							this.lists[i].nature = '自营'
						}
						if(data.data[i].nature == '2'){
							this.lists[i].nature = '联营'
						}
						if(data.data[i].nature == '3'){
							this.lists[i].nature = '出租'
						}
						if(data.data[i].nature == '4'){
							this.lists[i].nature = '物业动力'
						}
						if(data.data[i].nature == '5'){
							this.lists[i].nature = '居民配套'
						}
						if(data.data[i].nature == '9'){
							this.lists[i].nature = '备用'
						}
					}
		      	})
		        console.log(`当前页: ${val}`);
		    },
		},
		computed:{
			naturesData(){
				return this.natures = this.nature
			},
			...mapState(['nature'])
		}
	}
</script>

<style scoped="scoped">
	@media only screen and (min-width: 800px) and (max-width: 1280px) {
		.meter_search{
			height: 98px !important;
		}
	}

	.tab_col_a{
		display: block;
		width: 100%;
		height: 100%;
		color: #333;
		text-decoration: none;
	}

	.tab_col_a:hover{
		color: #4c98fd;
	}
</style>


// WEBPACK FOOTER //
// meterStatus.vue?068316ba